import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {ErrorAudioBoxs} from "../../../../components/ErrorAudio/ErrorAudioBoxs"

class ModalMessage extends Component {
    render() {
        const {message, isOpen, onClose, error, isRegen} = this.props
        ErrorAudioBoxs(error, isOpen)
        
        return (
            <div className='ModalMessage'>
                <Modal isOpen={isOpen} toggle={onClose} className={error !== '' ? 'modal-container' : ''}>
                    <ModalHeader>Gen lại Label</ModalHeader>
                    <ModalBody>
                        <div className='font-size-lg'>
                            {message !== '' && <p className={isRegen ? 'text-success' : 'text-danger'}>{message}</p>}
                            {error !== '' && <p className='text-danger display-4'>{error}</p>}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={onClose}>Đóng</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ModalMessage.propTypes = {
    isOpen: PropTypes.bool,
    message: PropTypes.string,
    onClose: PropTypes.func,
    error: PropTypes.string,
    isRegen: PropTypes.bool
}

export default ModalMessage